import React from 'react'
import { Modal } from 'components/common/Modal'
import BulkUploadModalContent from './components/BulkUploadModalContent/BulkUploadModalContent'
import BulkUploadProgress from './components/BulkUploadProgress/BulkUploadProgress'
import { UseMutateAsyncFunction } from 'react-query'
import { AxiosError } from 'axios'

interface Props {
  isModalVisible: boolean
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>
  taskID: string | undefined
  setTaskID: React.Dispatch<React.SetStateAction<string>>
  isUploading: boolean
  handleUpload: UseMutateAsyncFunction<any, AxiosError<any, any>, File, unknown>
}
const BulkUploadModal: React.FC<Props> = ({
  isModalVisible,
  setModalVisible,
  taskID,
  setTaskID,
  isUploading,
  handleUpload,
}) => {
  return (
    <Modal
      isOpen={isModalVisible}
      onClose={() => setModalVisible(false)}
      title="Add Domains"
      subtitle="Upload a File"
      message={
        taskID ? (
          <BulkUploadProgress
            taskID={taskID}
            setTaskID={setTaskID}
            setModalVisible={setModalVisible}
          />
        ) : (
          <BulkUploadModalContent
            setModalVisible={setModalVisible}
            setTaskID={setTaskID}
            isUploading={isUploading}
            handleUpload={handleUpload}
          />
        )
      }
      footer={null}
    />
  )
}

export default BulkUploadModal
